import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { ApplyModalProvider } from './components/ApplyModalContext';
import { ApplyModal } from './components/ApplyModal';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <ApplyModalProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <ScrollToTop data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<LandingPage data-id="element-5" />} data-id="element-4" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-7" />} data-id="element-6" />
          <Route path="/terms" element={<TermsPage data-id="element-9" />} data-id="element-8" />
        </Routes>
      </BrowserRouter>
      <ApplyModal data-id="element-10" />
    </ApplyModalProvider>;
}